import qs from 'qs';
function getNewLocation({ pathname, hash, search, resetPage, routeType }) {
    if (resetPage && search) {
        // Delete the page if there is one, so pagination gets reset
        delete search.page;
    }
    const stringifiedSearch = qs.stringify(search, {
        encodeValuesOnly: true,
        skipNulls: true
    });
    return {
        pathname,
        hash,
        search: stringifiedSearch,
        state: {
            type: routeType
        }
    };
}
export function pushHistory(args) {
    const { history } = args;
    history.push(getNewLocation(args));
    return args.search;
}
export function replaceHistory(args) {
    const { history } = args;
    history.replace(getNewLocation(args));
    return args.search;
}
//# sourceMappingURL=updateHistory.js.map